export default {"src":"https://s.sylndr.com/c-e456acf/_next/static/media/right-green-icon.04ea90b2.svg","height":10,"width":6,"blurWidth":0,"blurHeight":0};